'use client';

import useOrder from '@/core/hooks/use-order';
import useTranslations from '@/core/hooks/use-translations';
import { usePathname } from '@/core/i18n/routing';
import getBffCartItemCount from '@/core/utils/get-bff-cart-item-count';
import Button from '@/ui/components/Button/Button';
import { useGA4 } from '@/ui/context/ga4';
import cn from '@/ui/utils/cn/cn';

import $ from './CartLink.module.scss';

const CartLink = () => {
  const t = useTranslations();
  const pathname = usePathname();
  const { cart } = useOrder();
  const { trackMenuNavigation } = useGA4();
  const totalItems = getBffCartItemCount(cart);
  const isCartActive = pathname.startsWith('/cart');

  return (
    <Button
      href="/cart"
      ariaLabel={t('web_general_header_goToCart')}
      contentWrapperClassName={cn($.control, isCartActive && $.controlActive)}
      icon="icon-light-cart"
      iconClassName={$.icon}
      variant="tertiary"
      onClick={() =>
        trackMenuNavigation({
          menu: 'header',
          menu_path: '/cart',
          menu_text: 'Go to cart',
          menu_click: 'picture',
        })
      }
    >
      {totalItems > 0 && (
        <span
          className={$.total}
          aria-label={t('web_general_header_cartItems')}
        >
          {totalItems}
        </span>
      )}
    </Button>
  );
};

export default CartLink;
